import {Component, Host, h, Prop, Event, EventEmitter, Watch} from '@stencil/core';
import {Logger} from "../../utils/logger";

@Component({
  tag: 'securecall-request-secure-pan',
  styleUrl: 'securecall-request-secure-pan.css',
  shadow: true
})
export class SecurecallRequestSecurePan {
  @Prop() fieldName: string;
  @Prop() config: any;

  @Event() secureFieldResetEvent: EventEmitter<string>;

  private readonly log = new Logger('SecurecallRequestSecurePan')

  @Watch('config')
  handleConfigChange(newConfig: any, oldConfig: any) {
    this.log.debug(this.fieldName + ": handleConfigChange: config", newConfig, oldConfig);
  }

  handleClick(ev) {
    ev.preventDefault();
    this.log.debug("handleClick: field", this.fieldName, "clicked");
    this.config.valid = false;
    this.secureFieldResetEvent.emit(this.fieldName)
  }

  cardIconMap() {
    let iconList;

    iconList = (this.config.brands) ? this.config.brands : []
    return iconList.map(brand => {
      return <span><div class={`brand-icon icon-${brand}`} /></span>
    })
  }

  render() {
    return (
      <Host>
        <div class="field-container">
          <label class="custom-label" htmlFor={this.fieldName}>
            {this.config["label"]}: {this.config.active}
          </label>
          <div class="input-container">
            <input
              type="text"
              class={`custom-input ${this.config.active ? 'active' : 'inactive'}`}
              id={this.fieldName}
              readOnly
              placeholder={this.config.value}>
            </input>
            <div class="brand-icons-overlay">
              {this.cardIconMap()}
            </div>
          </div>
          <div class={this.config.valid ? 'field-valid' : 'field-invalid'} onClick={(ev) => this.handleClick(ev)}></div>
        </div>
      </Host>
  );
  }
  }
